'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.writetpl.list', [])
  .controller('WriteTplListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/writeTpl/list/index.js